import { render, staticRenderFns } from "./RootLayout.vue?vue&type=template&id=3b11ddcb&"
import script from "./RootLayout.vue?vue&type=script&lang=js&"
export * from "./RootLayout.vue?vue&type=script&lang=js&"
import style0 from "./RootLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports